import React, { useState } from 'react';
import OnboardingGoal from './OnboardingGoal';
import OnboardingPlacement from './OnboardingPlacement';

interface OnboardingFlowProps {
  onComplete: () => void;
  // Resumes at Placement if the caller already knows Goal was completed
  // server-side (e.g. the user refreshed mid-funnel) -- defaults to the
  // start of the funnel otherwise.
  initialStep?: 'goal' | 'placement';
}

const OnboardingFlow: React.FC<OnboardingFlowProps> = ({ onComplete, initialStep = 'goal' }) => {
  const [step, setStep] = useState<'goal' | 'placement'>(initialStep);

  if (step === 'goal') {
    return <OnboardingGoal onNext={() => setStep('placement')} />;
  }
  return <OnboardingPlacement onComplete={onComplete} />;
};

export default OnboardingFlow;
